import { render, staticRenderFns } from "./DisplayX19320.vue?vue&type=template&id=0016bfb8&"
import script from "./DisplayX19320.vue?vue&type=script&lang=js&"
export * from "./DisplayX19320.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports